import { keepPreviousData, useQuery } from "@tanstack/react-query";
import InventoryService from "../../../services/InventoryService";
import { useInventoryStore } from "../../../store/useInventoryStore";
import { INVENTORY_QUERY_KEYS } from "../useInventoryQueries";

export const useWarehouseProducts = (customParams = {}, options = {}) => {
  const selectedWarehouseId = useInventoryStore((state) => state.selectedWarehouseId);
  const appliedSearch = useInventoryStore((state) => state.appliedSearch);
  const page = useInventoryStore((state) => state.page);
  const pageSize = useInventoryStore((state) => state.pageSize);
  const ordering = useInventoryStore((state) => state.ordering);
  const appliedOrdering = useInventoryStore((state) => state.appliedOrdering);
  const isActive = useInventoryStore((state) => state.isActive);
  const appliedIsActive = useInventoryStore((state) => state.appliedIsActive);
  const dateFrom = useInventoryStore((state) => state.dateFrom);
  const appliedDateFrom = useInventoryStore((state) => state.appliedDateFrom);
  const dateTo = useInventoryStore((state) => state.dateTo);
  const appliedDateTo = useInventoryStore((state) => state.appliedDateTo);
  const setTotalCount = useInventoryStore((state) => state.setTotalCount);

  const params = {
    warehouseId: selectedWarehouseId,
    search: appliedSearch,
    page,
    pageSize,
    ordering: appliedOrdering,
    isActive: appliedIsActive,
    dateFrom: appliedDateFrom,
    dateTo: appliedDateTo,
    ...customParams,
  };

  const query = useQuery({
    queryKey: INVENTORY_QUERY_KEYS.warehouseProducts(params),
    queryFn: () => InventoryService.getWarehouseProducts(params),
    enabled: !!params.warehouseId,
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
    ...options,
  });

  const products = Array.isArray(query.data)
    ? query.data
    : Array.isArray(query.data?.results)
    ? query.data.results
    : [];

  const totalCount = query.data?.count ?? products.length;
  setTotalCount(totalCount)
  const totalPages = Math.ceil(totalCount / (params.pageSize || 10));

  return {
    ...query,
    products,
    totalCount,
    totalPages,
    params,
  };
};
